<script>
	import { PRConnect } from "@projectroom/ui-lib";
	import { onMount } from 'svelte';
	import axios from "axios";

	export let event;
	let refRankingViewCount;

	const changeRankingViewCount = () => {
		event.changeRankingViewCount(refRankingViewCount.value);
	}

	const changeRankingFlag = () => {
		event.changeRankingFlag();
	}

</script>
{#if event.isLoad}
<div data-w-tab="Tab 3" class="w-tab-pane" class:w--tab-active={event.currentTab === "rankingBoard"}>
	<div class="event-thumbnail-write-wrap">
		<div class="event-write _800px">
		<div class="admin-title-text _2">랭킹 보드</div>
		<div class="event-main-text">
			<div class="admin-title-text">랭킹보드 기능</div>
			<div class="lanking-setting">
			<div class="text-block-108">랭킹 보드</div>
			<div class="toggle-button _2" on:click={changeRankingFlag}>
				<div class="toggle" class:on={event.rankingFlag === "Y"}></div>
				<div class="toggle-round" class:on={event.rankingFlag === "Y"}></div>
			</div>
			</div>
		</div>
		<div class="personal-data-block-form">
			<div class="text-block-107">랭킹보드에 표시 할 개인정보</div>
			<div class="checkbox-wrap">
			<div class="checkbox-elements">
				<img alt="" loading="lazy" src="/static/images/check-icon.svg" class="chracter-checkbox">
				<div class="text-block-95">성함</div>
			</div>
			<div class="checkbox-elements">
				<img alt="" loading="lazy" src="/static/images/check-icon.svg" class="chracter-checkbox active">
				<div class="text-block-95">이메일</div>
			</div>
			<div class="checkbox-elements">
				<img alt="" loading="lazy" src="/static/images/check-icon.svg" class="chracter-checkbox">
				<div class="text-block-95">전화번호</div>
			</div>
			<div class="checkbox-elements">
				<img alt="" loading="lazy" src="/static/images/check-icon.svg" class="chracter-checkbox">
				<div class="text-block-95">인스타 주소</div>
			</div>
			</div>
		</div>
		<div class="personal-data-block-form">
			<div class="text-block-107">랭킹보드에 표시 할 순위</div>
			<div data-hover="false" data-delay="0" class="w-dropdown">
			<div class="gap-elements">
				<input type="number" class="gap-change-field w-input" name="name-3" data-name="Name 3" min="0" id="name-3" bind:this={refRankingViewCount} value={event.rankingViewCount} on:change={changeRankingViewCount}>
			</div>
			<nav class="w-dropdown-list" id="w-dropdown-list-2" aria-labelledby="w-dropdown-toggle-2">
				<a href="#" class="dropdown-link w-dropdown-link" tabindex="0">Link 1</a>
				<a href="#" class="w-dropdown-link" tabindex="0">Link 2</a>
				<a href="#" class="w-dropdown-link" tabindex="0">Link 3</a>
			</nav>
			</div>
		</div>
		</div>
	</div>
</div>
{/if}
<style>
	.active {
		background-color: #4c4fa7;
	}
	.toggle.on {
        border-color: #ff558d;
        border-radius: 30px;
        background-color: #ff558d;
    }

    .toggle {
        background-color: #999;
    }
</style>